import { render } from "./MobileJamakkol.vue?vue&type=template&id=445211b7&scoped=true"
import script from "./MobileJamakkol.vue?vue&type=script&lang=js"
export * from "./MobileJamakkol.vue?vue&type=script&lang=js"

import "./MobileJamakkol.vue?vue&type=style&index=0&id=445211b7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445211b7"]])

export default __exports__